import Form from "./Form";
import useYourCaravan from "./hooks/useYourCaravan";

export const YourCaravan: React.FC = () => {
  const props = useYourCaravan();
  return <Form {...props} />;
};
export default YourCaravan;
